import { useEffect } from 'react';

import { useCable } from './useCable';

/**
 * Hook that subscribes to the ReloadChannel and automatically reloads the page
 * when a reload command is received from the server
 */
export const useReloadChannel = () => {
  const cable = useCable();

  useEffect(() => {
    if (!cable) return;

    const subscription = cable.subscriptions.create(
      {
        channel: 'ReloadChannel',
      },
      {
        connected: (data: any) => {
          // eslint-disable-next-line no-console
          console.log('ReloadChannel#connected', data);
        },
        disconnected: (data: any) => {
          // eslint-disable-next-line no-console
          console.log('ReloadChannel#disconnected', data);
        },
        received: (data: any) => {
          // eslint-disable-next-line no-console
          console.log('ReloadChannel#received', data);
          if (data.action === 'reload') {
            // eslint-disable-next-line no-console
            console.log('Reload command received, reloading page...');
            window.location.reload();
          }
        },
      }
    );

    return () => {
      subscription.unsubscribe();
    };
  }, [cable]);
};
